import React from 'react';
import { Card, Typography, Divider, Row, Col, Avatar, Timeline } from 'antd';
import { UserOutlined, EnvironmentOutlined, BookOutlined, ExperimentOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const AboutPage = () => {
  return (
    <div style={{ 
      padding: '20px', 
      maxWidth: '1200px', 
      margin: '0 auto',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh'
    }}>
      <Card style={{ 
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(31, 38, 135, 0.2)',
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <Title level={1} style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: 10
          }}>
            中山大学地理科学与规划学院
          </Title>
          <Title level={2} style={{ color: '#2c3e50', marginBottom: 20 }}>
            孙伟课题组
          </Title>
          <Paragraph style={{ fontSize: '16px', color: '#5a6c7d' }}>
            专注于水文预报、机器学习与地理信息系统研究
          </Paragraph>
        </div>

        <Divider />

        <Row gutter={[32, 32]}>
          <Col xs={24} lg={12}>
            <Card 
              title="课题组简介" 
              bordered={false}
              style={{ height: '100%' }}
              headStyle={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                borderRadius: '8px 8px 0 0'
              }}
            >
              <Paragraph>
                孙伟课题组隶属于中山大学地理科学与规划学院，致力于水文气象预报技术创新与应用研究。
                课题组结合传统水文学理论与现代机器学习技术，开发了多项业务化水文气象预报系统。
              </Paragraph>
              
              <div style={{ marginTop: 20 }}>
                <Text strong><EnvironmentOutlined /> 研究方向：</Text>
                <ul style={{ marginTop: 10 }}>
                  <li>水文预报与洪水预警</li>
                  <li>机器学习在水文气象学中的应用</li>
                  <li>珠江流域水资源管理</li>
                  <li>气候变化与水循环</li>
                </ul>
              </div>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card 
              title="团队成员" 
              bordered={false}
              style={{ height: '100%' }}
              headStyle={{ 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                borderRadius: '8px 8px 0 0'
              }}
            >
              <div style={{ marginBottom: 20 }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 15 }}>
                  <Avatar size={48} icon={<UserOutlined />} style={{ marginRight: 12 }} />
                  <div>
                    <Text strong style={{ fontSize: '16px' }}>孙伟 副教授</Text>
                    <div style={{ color: '#666' }}>课题组负责人</div>
                  </div>
                </div>
                
                <Paragraph style={{ fontSize: '14px', margin: 0 }}>
                  主要从事水文气象预报、机器学习与自然地理、资源环境的交叉研究。
                </Paragraph>
              </div>

              <div style={{ background: '#f8fafc', padding: 15, borderRadius: 8 }}>
                <Text strong>研究团队包括：</Text>
                <ul style={{ margin: '10px 0 0 0' }}>
                  <li>副教授 3名</li>
                  <li>硕士研究生 4名</li>
                  <li>本科生 3名</li>
                </ul>
              </div>
            </Card>
          </Col>
        </Row>

        <Divider style={{ margin: '40px 0' }} />

        <Card 
          title="主要成果" 
          bordered={false}
          headStyle={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            borderRadius: '8px 8px 0 0'
          }}
        >
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Timeline
                items={[
                  {
                    dot: <ExperimentOutlined style={{ fontSize: '16px' }} />,
                    children: (
                      <div>
                        <Text strong>多模型集成预报系统</Text>
                        <div style={{ color: '#666', marginTop: 4 }}>
                          集成LSTM、CNN、SVM等多种机器学习模型，提高预报精度
                        </div>
                      </div>
                    ),
                  },
                  {
                    dot: <BookOutlined style={{ fontSize: '16px' }} />,
                    children: (
                      <div>
                        <Text strong>珠江流域预报平台</Text>
                        <div style={{ color: '#666', marginTop: 4 }}>
                          覆盖珠江流域主要水文站点，实现业务化运行
                        </div>
                      </div>
                    ),
                  },
                  {
                    dot: <UserOutlined style={{ fontSize: '16px' }} />,
                    children: (
                      <div>
                        <Text strong>人才培养</Text>
                        <div style={{ color: '#666', marginTop: 4 }}>
                          培养水文预报专业人才10余名
                        </div>
                      </div>
                    ),
                  },
                ]}
              />
            </Col>
            
            <Col xs={24} md={12}>
              <div style={{ background: '#f0f8ff', padding: 20, borderRadius: 8 }}>
                <Title level={4} style={{ margin: '0 0 15px 0' }}>发表论文</Title>
                <ul style={{ margin: 0 }}>
                  <li>SCI论文 近80篇</li>
                  <li>中文核心期刊 5篇</li>
                </ul>
                
                <Title level={4} style={{ margin: '20px 0 15px 0' }}>项目承担与参与</Title>
                <ul style={{ margin: 0 }}>
                  <li>国家自然科学基金 2项</li>
                  <li>省部级项目 3项</li>
                  <li>企业合作项目 1项</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Card>

        <Divider style={{ margin: '40px 0' }} />

        <div style={{ textAlign: 'center', background: '#f8fafc', padding: 20, borderRadius: 8 }}>
          <Title level={3} style={{ color: '#2c3e50' }}>联系方式</Title>
          <Paragraph style={{ marginBottom: 8 }}>
            <EnvironmentOutlined style={{ marginRight: 8 }} />
            地址：广州大学城外环东路132号中山大学广州校区东校园 中山大学地理科学与规划学院
          </Paragraph>
          <Paragraph style={{ marginBottom: 8 }}>
            邮编：510006
          </Paragraph>
          <Paragraph style={{ marginBottom: 0 }}>
            邮箱：sunwei29@mail.sysu.edu.cn
          </Paragraph>
        </div>
      </Card>
    </div>
  );
};

export default AboutPage;